import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/slw/shared/lib/utils';

const textareaVariants = cva(
  `flex min-h-[60px] w-full rounded-md border bg-transparent px-3 py-2 text-base
          placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring
          disabled:cursor-not-allowed disabled:opacity-50 md:text-sm transition-all duration-200 ease-in-out`,
  {
    variants: {
      color: {
        default: 'bg-secondary text-gray-900 focus-visible:ring-default',
        white: 'bg-secondary text-gray-900 focus-visible:ring-default',
        main: 'bg-primary text-secondary-foreground focus-visible:ring-default',
        darkBlue: 'bg-dark-blue-input text-white focus-visible:ring-default',
        darkGrey: 'bg-dark-grey-input text-white focus-visible:ring-default',
        grey: 'bg-gray-input text-gray-900 focus-visible:ring-default',
        light: 'bg-light-input text-gray-900 focus-visible:ring-default',
      },
    },
    defaultVariants: {
      color: 'default',
    },
  },
);

interface TextareaProps
  extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'color'>,
    VariantProps<typeof textareaVariants> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, color = 'default', ...props }, ref) => {
    return <textarea className={cn(textareaVariants({ color }), className)} ref={ref} {...props} />;
  },
);

Textarea.displayName = 'Textarea';

export { Textarea };
